import React from 'react';
import styled from 'styled-components';

import { CleaningPrestation } from '@front/common/src/types/commons';

import { translate } from '@front/i18n';

import Text from '@front/web-ui/src/components/base-text/variants/text';
import TextButton from '@front/web-ui/src/components/button/text-button';

const t = translate('basket.membership.card');

const BlockTitle = styled(Text.SMBold)`
  display: block;
`;

type NotMemberWithRecurringPrestationProps = {
  getMoreInfoPress: () => void;
  cleaningPrestation?: CleaningPrestation;
};

const NotMemberWithRecurringPrestation = ({
  getMoreInfoPress,
  cleaningPrestation,
}: NotMemberWithRecurringPrestationProps) => {
  const cleaningPrestationTitle = cleaningPrestation?.title.toLowerCase() || '';

  return (
    <span>
      <BlockTitle>{t('.cleaning.recurring.text_1')}</BlockTitle>
      <Text.SM>{`${t('.cleaning.recurring.text_2', { prestation: cleaningPrestationTitle })} `}</Text.SM>
      <TextButton size='sm' onClick={getMoreInfoPress}>
        {t('.more_info_link')}
      </TextButton>
    </span>
  );
};

export default NotMemberWithRecurringPrestation;
